import axios from 'axios'
import ElementUI from 'element-ui';
import Router from 'vue-router'
import { MessageBox, Message } from 'element-ui'
axios.defaults.baseURL = 'https://wkonline.com.cn/web-api/'
//axios.defaults.baseURL = 'http://9.frp.liziup.com/web-api/'
//axios.defaults.baseURL = 'http://qb98qk.natappfree.cc/web-api/'
//http://39.105.100.231:8430
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8;multipart/form-data'
axios.defaults.headers['Cache-Control'] = 'no-cache'
axios.defaults.withCredentials = true
axios.interceptors.request.use(function (config) {
  if (localStorage.getItem('token')) {
    config.headers.token = localStorage.getItem('token')
  }
  return config
})
// http响应拦截器
axios.interceptors.response.use(res => {
  var code = res.httpStatus
  if (res.data.code == -1) {
    Message({
      message: res.data.msg,
      type: 'error',
      duration: 5 * 1000
    })
  } else {
    return res;
  }

},
  error => {
    return Promise.reject(error)
  }
)
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err.data)
    })
  })
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
/**
 * PUT方法，对应PUT请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function put(url, params) {
  return new Promise((resolve, reject) => {
    axios.put(url, params)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}

/**
 * delete方法，对应PUT请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function deletes(url, params) {
  return new Promise((resolve, reject) => {
    axios.delete(url, params)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}


// WEBPACK FOOTER //
// ./src/request/http.js